import React, { Component } from 'react';
import Spinner from 'react-bootstrap/Spinner'
import { isMobileOnly } from "react-device-detect";

import { StringUtils } from '../utils';
import { Header, Button, Switch, Input, PhoneInput, Line } from '../components';
import { History as history, Routes as routes } from '../navigation';
import '../css/CreatePractice.css';

class CreatePractice extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display_section: 'plans',
      display_yearly: true,
      loading_subscribe: false,
      displayCreateComponents: false,
      selected_plan: 'instant',
      practice_name: '',
      practice_location_name: '',
      practice_street_address: '',
      practice_city: '',
      practice_state: '',
      practice_zipcode: '',
      practice_phone_number: '',
      cardholder_name: '',
      card_number: '',
      card_month: '',
      card_year: '',
      card_cvv: '',
      billing_street_address: '',
      billing_street_address_line_2: '',
      billing_city: '',
      billing_state: '',
      billing_zipcode: '',
      contact_name: '',
      contact_phone_number: '',
      contact_email: '',
      subscription_types: [],
      core_yearly: true
    }

    this.switchCoreTimeFrame = this.switchCoreTimeFrame.bind(this);
  }

  componentDidMount() {
    let token = this.props.token;

    this.props.practiceActions.getSubscriptionTypes(token, (subscription_types) => {
      this.setState({ ...this.state, subscription_types: subscription_types });
    });
  }

  renderCreatePractice = () => {
    let display_section = this.state.display_section;
    if (display_section === 'intro') {
      return this.renderIntro();
    }
    if (display_section === 'plans') {
      return this.renderPlansTable();
    }
    if (display_section === 'practice_details') {
      return this.renderPracticeDetails();
    }
    if (display_section === 'payment') {
      return this.renderPaymentSection();
    }
    if (display_section === 'contact') {
      return this.renderContactSection();
    }
    if (display_section === 'summary') {
      return this.renderSummarySection();
    }
  }

  renderContactSection = () => {
    let height       = isMobileOnly ? 400 : '';
    let width        = isMobileOnly ? 300 : 900;
    let left_padding = isMobileOnly ? 0   : 50;
    let btn_width    = isMobileOnly ? 200 : 300;

    return <div className="standard-container" style={{ maxWidth: width, width: width, minWidth: width, height: height, maxHeight: height, minHeight: height }}>
      <div className="flex-container-column" style={{ padding: 15, justifyContent: 'space-between', height: '100%' }}>
        { this.renderProgressBar() }

        <div className='flex-container-row' style={{ justifyContent: 'center', paddingBottom: 60 }}>

          <div className='flex-container-column' style={{ width: 350, paddingLeft: left_padding }}>
            <div className='flex-container-row' style={{ width: 250, alignItems: 'flex-start', marginBottom: 10 }}>
              <span className='fas fa-address-book' style={{ color: '#1dc2ff', marginRight: 10, marginTop: 0, paddingTop: 1 }} />
              <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Contact Information</span>
            </div>

            <Input placeholder="Contact Name"
                   value={this.state.contact_name}
                   className='instant-input-default'
                   style={{ width: 265, marginBottom: 5 }}
                   onChange={ (event) => { this.setState({ ...this.state, contact_name: event.target.value }) }}
                  />
            <Input placeholder="Contact Email Address"
                   value={this.state.contact_email}
                   className='instant-input-default'
                   style={{ width: 265, marginBottom: 5 }}
                   onChange={ (event) => { this.setState({ ...this.state, contact_email: event.target.value }) }}
                  />

            <PhoneInput value={this.state.contact_phone_number}
                        style={{ fontSize: 13 }}
                        placeholder='Contact Phone #'
                        containerStyle={{ width: 265 }}
                        onChange={ (phone_number) => { this.setState({ ...this.state, contact_phone_number: phone_number }) }}/>

          </div>
        </div>

        <Button value='Continue'
                style={{ alignSelf: 'center', width: btn_width, paddingTop: 10, paddingBottom: 10, textAlign: 'center' }}
                onClick={ () => {
                  let can_proceed = this.validateContactInfo();

                  if (!can_proceed) {
                    this.props.toastActions.displayError('Missing contact info.');
                    return;
                  }
                  this.setState({ ...this.state, display_section: 'summary' });
                }}/>
      </div>
    </div>
  }

  renderPaymentSection = () => {
    let width         = isMobileOnly ? 300 : 900;
    let height        = isMobileOnly ? 400 : 455;
    let btn_width     = isMobileOnly ? 260 : 300;

    let side_margins  = isMobileOnly ? 0   : 30;
    let flex_type     = isMobileOnly ? 'flex-container-column' : 'flex-container-row';

    return <div className="standard-container" style={{ maxWidth: width, width: width, minWidth: width, height: '', maxHeight: '', minHeight: '' }}>
      <div className="flex-container-column" style={{ padding: 15, justifyContent: 'space-between', height: '100%' }}>
        { this.renderProgressBar() }

        <div className={ flex_type } style={{ justifyContent: 'center', paddingBottom: 60 }}>

          <div className='flex-container-column' style={{ width: 350, marginRight: 8, paddingLeft: 0 }}>
            <div className='flex-container-row' style={{ width: 250, alignItems: 'flex-start', marginBottom: 10 }}>
              <span className='fas fa-credit-card' style={{ color: '#1dc2ff', marginRight: 8, marginTop: 1 }} />
              <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Credit Card Info</span>
            </div>

            <Input placeholder="Cardholder Name"
                   value={this.state.cardholder_name}
                   className='instant-input-default'
                   style={{ width: 265, marginBottom: 5}}
                   onChange={ (event) => { this.setState({ ...this.state, cardholder_name: event.target.value }) }}
                  />

            <Input placeholder="Card Number"
                   value={this.state.card_number}
                   className='instant-input-default'
                   style={{ width: 265, marginBottom: 5}}
                   onChange={ (event) => { this.setState({ ...this.state, card_number: event.target.value }) }}
                  />

            <div className='flex-container-row'>
              <div className='flex-container-row'>
                <Input placeholder="MM"
                       value={this.state.card_month}
                       className='instant-input-default'
                       style={{ width: 50, marginBottom: 5, marginRight: 5, textAlign: 'center', padding: 0 }}
                       onChange={ (event) => { this.setState({ ...this.state, card_month: event.target.value }) }}
                      />
                <Input placeholder="YY"
                       value={this.state.card_year}
                       className='instant-input-default'
                       style={{ width: 50, marginBottom: 5, textAlign: 'center', padding: 0 }}
                       onChange={ (event) => { this.setState({ ...this.state, card_year: event.target.value }) }}
                      />
              </div>
              <div className='flex-container-row'>
                <Input placeholder="CVV"
                       value={this.state.card_cvv}
                       className='instant-input-default'
                       style={{ width: 100, marginBottom: 5, marginLeft: 60, textAlign: 'center', padding: 0 }}
                       onChange={ (event) => { this.setState({ ...this.state, card_cvv: event.target.value }) }}
                      />
              </div>
            </div>
          </div>

          <Line hide={!isMobileOnly} style={{ marginTop: 20, marginBottom: 20 }} />

          <div className='flex-container-column' style={{ width: 350 }}>
            <div className='flex-container-row' style={{ width: 250, alignItems: 'flex-start', marginBottom: 10 }}>
              <span className='fas fa-map-marked-alt' style={{ color: '#1dc2ff', marginRight: 10, marginTop: 0 }} />
              <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Billing Address</span>
            </div>

            <Input placeholder="Street Address"
                   value={this.state.billing_street_address}
                   className='instant-input-default'
                   style={{ width: 265, marginBottom: 5 }}
                   onChange={ (event) => { this.setState({ ...this.state, billing_street_address: event.target.value }) }}
                  />

            <Input placeholder="Street Address Line 2  (Optional)"
                   value={this.state.billing_street_address_line_2}
                   className='instant-input-default'
                   style={{ width: 265, marginBottom: 5 }}
                   onChange={ (event) => { this.setState({ ...this.state, billing_street_address_line_2: event.target.value }) }}
                  />

            <div className='flex-container-row'>
              <Input placeholder="City"
                     value={this.state.billing_city}
                     className='instant-input-default'
                     style={{ width: 180, marginRight: 5 }}
                     onChange={ (event) => { this.setState({ ...this.state, billing_city: event.target.value }) }}
                    />
              <Input placeholder="State"
                     value={this.state.billing_state}
                     className='instant-input-default'
                     style={{ width: 80, marginRight: 5 }}
                     onChange={ (event) => { this.setState({ ...this.state, billing_state: event.target.value }) }}
                    />
            </div>

            <div style={{ marginTop: 5 }}>
              <Input placeholder="Zipcode"
                     value={this.state.billing_zipcode}
                     className='instant-input-default'
                     style={{   width: 100  }}
                     onChange={ (event) => { this.setState({ ...this.state, billing_zipcode: event.target.value }) }}
                    />
            </div>

          </div>
        </div>

        <Button value='Continue'
                style={{ alignSelf: 'center', width: btn_width, paddingTop: 10, paddingBottom: 10, textAlign: 'center' }}
                onClick={ () => {
                  let can_proceed = this.validatePayment();

                  if (!can_proceed) {
                    this.props.toastActions.displayError('Missing payment details.');
                    return;
                  }
                  this.setState({ ...this.state, display_section: 'summary' });
                }}/>
      </div>
    </div>
  }

  renderSummarySection = () => {
    let last_4_digits   = '';
    let display_billing = this.state.selected_plan === 'instant_paid' || this.state.selected_plan === 'core';
    let display_contact = this.state.selected_plan === 'enterprise';

    if (this.state.card_number && this.state.card_number.length > 4) {
      last_4_digits = this.state.card_number.substr(this.state.card_number.length - 4);
    }

    let plan_label      = this.state.selected_plan === 'instant_paid' ? 'Instant+'     : 'Instant';
        plan_label      = this.state.selected_plan === 'core'         ? 'Professional' : plan_label;
        plan_label      = this.state.selected_plan === 'enterprise'   ? 'Enterprise'   : plan_label;

    let plan_details = this.getPlanDetails(this.state.selected_plan);
    let price_label     = ['core', 'instant_paid', 'enterprise'].indexOf(this.state.selected_plan) !== -1 ? plan_details.price_yer  : 'FREE';

    let summary_message = plan_details.summary_message;

    if(this.state.selected_plan === 'core' && !this.state.core_yearly) {
      price_label = plan_details.price_mon;
      summary_message = plan_details.summary_message_month;
    }

    let width         = isMobileOnly ? 300 : 900;
    let height        = isMobileOnly ? 400 : 455;
    let btn_width     = isMobileOnly ? ''  : 300;
    let btn_flex      = isMobileOnly ? 1   :  '';
    let msg_width     = isMobileOnly ? 265 : 220;

    let side_margins  = isMobileOnly ? 0   : 30;
    let flex_type     = isMobileOnly ? 'flex-container-column' : 'flex-container-row';


    return <div className='flex-container-row'>
      <div className="standard-container" style={{ maxWidth: width, width: width, minWidth: width, justifyContent: 'space-between' }}>
        <div className="flex-container-column" style={{ padding: 15, justifyContent: 'space-between', height: '100%' }}>
          { this.renderProgressBar() }

          <div className={ flex_type } style={{ justifyContent: 'center' }}>

            <div className='flex-container-column' style={{ height: '100%', marginRight: side_margins, marginLeft: side_margins }}>
              <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <div className='flex-container-row'>
                  <span className='fas fa-clinic-medical' style={{ color: '#1dc2ff', marginRight: 5, marginTop: 0 }} />
                  <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Practice Details</span>
                </div>
                <div style={{ marginLeft: 40 }}>
                  <span className='fas fa-edit icon-button' onClick={ () => { this.setState({ ...this.state, display_section: 'practice_details' }) }} />
                </div>
              </div>
              <div className='flex-container-column' style={{  }}>
                <span style={{ color: 'grey', fontSize: 14, marginBottom: 10 }}>{ this.state.practice_name}</span>
                <span style={{ color: 'grey', fontSize: 14 }}>{ this.state.practice_location_name }</span>
                <span style={{ color: 'grey', fontSize: 14 }}>{ this.state.practice_street_address }</span>
                <span style={{ color: 'grey', fontSize: 14, marginBottom: 10 }}>{ this.state.practice_city + ' ' + this.state.practice_state + ', ' + this.state.practice_zipcode }</span>
                <span style={{ color: 'grey', fontSize: 14 }}>{ StringUtils.displayCodePhoneNumber(this.state.practice_phone_number) }</span>
              </div>
            </div>

            <Line hide={!isMobileOnly || !display_billing} style={{ backgroundColor: '#eeeeee', marginTop: 20, marginBottom: 20 }}/>

            { display_billing
            ? <div className='flex-container-column'>
              <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <div className='flex-container-row'>
                  <span className='fas fa-credit-card' style={{ color: '#1dc2ff', marginRight: 10, marginTop: 1 }} />
                  <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Billing Info</span>
                </div>
                <div style={{ marginLeft: 60 }}>
                  <span className='fas fa-edit icon-button' onClick={ () => { this.setState({ ...this.state, display_section: 'payment' }) }} />
                </div>
              </div>
              <div className='flex-container-column' style={{  }}>
                <span style={{ color: 'grey', fontSize: 14 }}>{ this.state.cardholder_name }</span>
                <span style={{ color: 'grey', fontSize: 14, alignItems: 'center' }} className='flex-container-row' >
                  <span className='fas fa-star-of-life' style={{ fontSize: 8, marginRight: 1, marginBottom: 2 }} />
                  <span className='fas fa-star-of-life' style={{ fontSize: 8, marginRight: 1, marginBottom: 2 }} />
                  <span className='fas fa-star-of-life' style={{ fontSize: 8, marginRight: 1, marginBottom: 2 }} />
                  <span className='fas fa-star-of-life' style={{ fontSize: 8, marginRight: 1, marginBottom: 2 }} />
                  { ' ' + last_4_digits }
                </span>
                <span style={{ color: 'grey', fontSize: 14, marginTop: 10 }}>{ this.state.billing_street_address }</span>
                { this.state.billing_street_address_line_2 ? <span style={{ color: 'grey', fontSize: 14 }}>{ this.state.billing_street_address_line_2 }</span> : null }
                <span style={{ color: 'grey', fontSize: 14, marginBottom: 10 }}>{ this.state.billing_city + ' ' + this.state.billing_state + ', ' + this.state.billing_zipcode }</span>
              </div>
            </div>
            : null }

            <Line hide={!isMobileOnly || !display_contact} style={{ backgroundColor: '#eeeeee', marginTop: 20, marginBottom: 20 }}/>

            { display_contact
            ? <div className='flex-container-column' style={{ height: '100%' }}>
              <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <div className='flex-container-row'>
                  <span className='fas fa-address-book' style={{ color: '#1dc2ff', marginRight: 10, marginTop: 1 }} />
                  <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Contact Info</span>
                </div>
                <div style={{ marginLeft: 60 }}>
                  <span className='fas fa-edit icon-button' onClick={ () => { this.setState({ ...this.state, display_section: 'contact' }) }} />
                </div>
              </div>
              <div className='flex-container-column' style={{  }}>
                <span style={{ color: 'grey', fontSize: 14 }}>{ this.state.contact_name }</span>
                <span style={{ color: 'grey', fontSize: 14 }}>{ this.state.contact_email }</span>
                <span style={{ color: 'grey', fontSize: 14 }}>{ StringUtils.displayCodePhoneNumber(this.state.contact_phone_number) }</span>
              </div>
            </div>
            : null }

            <Line hide={!isMobileOnly} style={{ backgroundColor: '#eeeeee', marginTop: 20, marginBottom: 20 }}/>

            <div className='flex-container-column' style={{ marginRight: side_margins, marginLeft: side_margins, marginBottom: side_margins }}>
              <div className='flex-container-row' style={{ width: 220, alignItems: 'flex-start', marginBottom: 10 }}>
                <span className='fas fa-sync-alt' style={{ color: '#1dc2ff', marginRight: 10, marginTop: 1 }} />
                <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Subscription Details</span>
              </div>
              <div className='flex-container-column'>
                <span style={{ color: 'grey', fontSize: 14 }}><span style={{ fontWeight: 'bold' }}>Plan:</span><span style={{ color: '#1dc2ff', marginLeft: 5 }}>{ plan_label }</span></span>
                { price_label ? <span style={{ color: 'grey', fontSize: 14 }}><span style={{ fontWeight: 'bold' }}>Rate:</span><span style={{ color: '#1dc2ff', marginLeft: 5 }}>{ price_label }</span></span> : null }
                <span style={{ color: 'grey', fontSize: 14, width: msg_width, marginTop: 10 }}>By selecting “Subscribe & Create Practice,” you hereby agree to TeleTails’
                <a className="tos-link" style={{ color: '#1dc2ff' }} target="_blank" href="https://www.teletails.com/tos"> Terms Of Service </a>
                as well as the subscription rate (“Rate”) stated above.</span>
              </div>
            </div>


          </div>

          <div style={{ height: 20 }}>
          </div>
          <div className='flex-container-row' style={{ justifyContent: 'center' }}>
            <Button value='Subscribe & Create Practice'
                    style={{ alignSelf: 'center', width: btn_width, flex: btn_flex, paddingTop: 20, paddingBottom: 20, textAlign: 'center' }}
                    loading={this.state.loading_subscribe}
                    onClick={ () => {
                      this.processCreatePractice();
                    }}/>
          </div>

        </div>
      </div>
    </div>
  }

  renderPracticeDetails = () => {
    let is_instant    = this.state.selected_plan === 'instant';
    let is_enterprise = this.state.selected_plan === 'enterprise';

    let width         = isMobileOnly ? 300 : 900;
    let height        = isMobileOnly ? 400 : 455;
    let btn_width     = isMobileOnly ? 200 : 300;
    let line_width    = isMobileOnly ? 265 : 300;

    return <div className="standard-container" style={{ maxWidth: width, width: 900, minWidth: width, height: height, maxHeight: height, minHeight: height }}>
      <div className="flex-container-column" style={{ padding: 15 }}>
        { this.renderProgressBar() }

        <div className='flex-container-column' style={{ alignItems: 'center', paddingRight: 20 }}>
          <div className='flex-container-row' style={{ width: 250, alignItems: 'flex-start', marginBottom: 10 }}>
            <span className='fas fa-clinic-medical' style={{ color: '#1dc2ff', marginRight: 5, marginTop: 0 }} />
            <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Practice Details</span>
          </div>
          <Input placeholder="Practice Name"
                 value={this.state.practice_name}
                 className='instant-input-default'
                 style={{ width: 265, marginLeft: 15, marginBottom: 15}}
                 onChange={ (event) => { this.setState({ ...this.state, practice_name: event.target.value }) }}
                />

          <Line style={{ marginBottom: 15, marginLeft: 15, width: line_width }} />

          <div className='flex-container-row' style={{ width: 250, alignItems: 'flex-start', marginBottom: 10 }}>
            <span className='fas fa-building' style={{ color: '#1dc2ff', marginRight: 5, marginTop: 0 }} />
            <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Location Details</span>
          </div>
          <Input placeholder="Location Name"
                 value={this.state.practice_location_name}
                 className='instant-input-default'
                 style={{ width: 265, marginLeft: 15, marginBottom: 5 }}
                 onChange={ (event) => { this.setState({ ...this.state, practice_location_name: event.target.value }) }}
                />
          <Input placeholder="Street Address"
                 value={this.state.practice_street_address}
                 className='instant-input-default'
                 style={{ width: 265, marginLeft: 15 }}
                 onChange={ (event) => { this.setState({ ...this.state, practice_street_address: event.target.value }) }}
                />

          <div className='flex-container-row' style={{ marginLeft: 15, paddingLeft: 15, paddingRight: 15, marginTop: 5, marginBottom: 5 }}>

            <Input placeholder="City"
                   value={this.state.practice_city}
                   className='instant-input-default'
                   style={{ width: 180, marginRight: 5 }}
                   onChange={ (event) => { this.setState({ ...this.state, practice_city: event.target.value }) }}
                  />
            <Input placeholder="State"
                   value={this.state.practice_state}
                   className='instant-input-default'
                   style={{ width: 80 }}
                   onChange={ (event) => { this.setState({ ...this.practice_state, practice_state: event.target.value }) }}
                  />
          </div>

          <div className='flex-container-column' style={{ width: 265, marginLeft: 15, alignItems: 'flex-end' }}>
            <Input placeholder="Zipcode"
                   value={this.state.practice_zipcode}
                   className='instant-input-default'
                   style={{   width: 80  }}
                   onChange={ (event) => { this.setState({ ...this.state, practice_zipcode: event.target.value }) }}
                  />
          </div>

          <div className='flex-container-column' style={{ paddingLeft: 15, paddingTop: 5, marginBottom: 20 }}>
            <PhoneInput value={this.state.practice_phone_number}
                        style={{ fontSize: 13 }}
                        placeholder='Office Phone #'
                        containerStyle={{ width: 265 }}
                        onChange={ (phone_number) => { this.setState({ ...this.state, practice_phone_number: phone_number }) }}/>
          </div>

        </div>

        <Button value='Continue'
                style={{ alignSelf: 'center', width: btn_width, paddingTop: 10, paddingBottom: 10, textAlign: 'center' }}
                onClick={ () => {
                  let can_proceed = this.validatePracticeDetails();

                  if (!can_proceed) {
                    this.props.toastActions.displayError('Missing practice details.');
                    return;
                  }

                  if (is_enterprise) {
                    this.setState({ ...this.state, display_section: 'contact' });
                  } else if (is_instant) {
                    this.setState({ ...this.state, display_section: 'summary' });
                  } else {
                    this.setState({ ...this.state, display_section: 'payment' });
                  }
                }}/>
      </div>
    </div>
  }

  renderProgressBar = () => {
     let hide_bar   = isMobileOnly ? true : false;
     let sect       = this.state.display_section;
     let on_payment = sect === 'payment';
     let on_summary = sect === 'summary';
     let on_contact = sect === 'contact';

     let practice_dot_class = on_payment || on_contact || on_summary ? 'fas fa-dot-circle' : 'far fa-dot-circle';
     let payment_dot_class  = sect === 'practice_details' ? 'far fa-circle'     : 'far fa-dot-circle';
         payment_dot_class  = on_summary                  ? 'fas fa-dot-circle' : payment_dot_class;
     let summary_dot_class  = on_summary                  ? 'far fa-dot-circle' : 'far fa-circle';

     let hide_payment    = this.state.selected_plan === 'instant' || this.state.selected_plan === 'enterprise';
     let display_contact = this.state.selected_plan === 'enterprise';

     if (hide_bar) {
       return null;
     }

    return <div className='flex-container-column' style={{ marginBottom: 15 }}>

      <div className='flex-container-row' style={{ alignItems: 'center', marginBottom: 5 }}>
        <div className='flex-container-column' style={{ paddingLeft: 45, color: '#1dc2ff' }}>
          <span className='fas fa-dot-circle' />
        </div>
        <div className='create-practice-progress-bar-lines' style={{ backgroundColor: '#1dc2ff' }}></div>
        <div className='flex-container-column' style={{ color: '#1dc2ff' }}>
          <span className={ practice_dot_class } />
        </div>
        { hide_payment ? null : <div className='create-practice-progress-bar-lines' style={{ backgroundColor: on_payment || on_summary ? '#1dc2ff' : '' }}></div> }
        { hide_payment ? null : <div className='flex-container-column' style={{ color: on_payment || on_summary ? '#1dc2ff' : 'grey'}}>
          <span className={ payment_dot_class } />
        </div> }
        { display_contact ? <div className='create-practice-progress-bar-lines' style={{ backgroundColor: on_contact || on_summary ? '#1dc2ff' : '' }}></div> : null }
        { display_contact ? <div className='flex-container-column' style={{ color: on_contact || on_summary ? '#1dc2ff' : 'grey'}}>
          <span className={ payment_dot_class } />
        </div> : null }
        <div className='create-practice-progress-bar-lines' style={{ backgroundColor: on_summary ? '#1dc2ff' : '' }}></div>
        <div className='flex-container-column' style={{ paddingRight: 45, color: on_summary ? '#1dc2ff' : 'grey' }}>
          <span className={ summary_dot_class } />
        </div>
      </div>

      <div className='flex-container-row' style={{ }}>
        <div className='create-practice-progress-bar-labels'>
          <span style={{ fontSize: 13 }}>Plan Selection</span>
        </div>
        <div style={{ flex: 1 }}></div>
        <div  className='create-practice-progress-bar-labels'>
          <span style={{ fontSize: 13 }}>Practice Details</span>
        </div>
        { hide_payment ? null : <div style={{ flex: 1 }}></div> }
        { hide_payment ? null : <div className='create-practice-progress-bar-labels'>
          <span style={{ fontSize: 13 }}>Payment Info</span>
        </div> }
        { display_contact ? <div style={{ flex: 1 }}></div> : null }
        { display_contact ? <div className='create-practice-progress-bar-labels'>
          <span style={{ fontSize: 13 }}>Contact Info</span>
        </div> : null }
        <div style={{ flex: 1 }}></div>
        <div className='create-practice-progress-bar-labels'>
          <span style={{ fontSize: 13 }}>Summary</span>
        </div>
      </div>

    </div>
  }

  renderPlansTable = () => {
    let continue_btn_title   = this.getContinueButtonTitle();
    let width                = isMobileOnly ? 300 : 900;
    let plan_container_style = isMobileOnly ? { overflow: 'scroll', paddingBottom: 10 } : {};

    return <div className="standard-container" style={{ maxWidth: width, width: width, minWidth: width }}>
      <div className="flex-container-column" style={{ padding: 15 }}>

        <span style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 0, color: '#575757', paddingLeft: 5 }}>Create A New Practice</span>
        <span style={{ fontSize: 13, color: '#1dc2ff', marginBottom: 5, marginTop: -3, paddingLeft: 5 }}>Start by selecting a plan for your practice</span>

        <div className='flex-container-row' style={plan_container_style}>
          { this.renderPlanColumn('instant') }
          { this.renderPlanColumn('instant_paid') }
          { this.renderPlanColumn('core') }
          { this.renderPlanColumn('enterprise') }
        </div>

        <div className='flex-container-column' style={{ marginTop: 15, marginBottom: 5, alignItems: 'center' }}>
          <Button value={continue_btn_title}
                  style={{ width: 250, textAlign: 'center', paddingTop: 18, paddingBottom: 18 }}
                  onClick={ () => {
                    this.setState({ ...this.state, display_section: 'practice_details' });
                  }}/>
        </div>

      </div>
    </div>
  }

  switchCoreTimeFrame() {
    let core_yearly = !this.state.core_yearly;
    let plan_details    = this.getPlanDetails('core');
    let subscription_amount = core_yearly ? plan_details.subscription_amount : plan_details.subscription_amount_month;

    let date_now = new Date();
    date_now.setHours(23, 59, 59, 59);
    let proration_date = Math.floor(date_now / 1000);

    let token       = this.props.token;
    let practice    = this.props.practice;
    let practice_id = practice && practice._id ? practice._id : '';

    this.props.practiceActions.getProration(token, practice_id, subscription_amount, proration_date, core_yearly ? 'year' : 'month', (data) => {
      console.log('data', data)
      let prorated_amount_remaining;
      if(data && data.proration_amount) {
        prorated_amount_remaining = data.proration_amount / 100;
      }
      this.setState({
        prorated_amount_remaining,
        core_yearly
      })
    });
  }

  renderPlanColumn = (plan_key) => {

    let plan_details = this.getPlanDetails(plan_key);

    let selected  = plan_key === this.state.selected_plan;
    let plan_name = plan_details.plan_name;
    let plan_sub  = plan_details.plan_sub;
    let features  = plan_details.features || [];
    let price_yer = plan_details.price_yer;
    let price_mon = plan_details.price_mon;
    let hide_switch = plan_details.hide_switch;
    let btn_title   = plan_details.btn_title;

    let features_rows = features.map((feature, i) => {
      return <span className='flex-container-row' style={{ alignItems: 'flex-start', marginTop: 5, paddingLeft: 10 }} key={i}>
        <span className='fas fa-check-circle' style={{ color: '#1dc2ff', fontSize: 14, marginTop: 3, marginRight: 10 }}/>
        <span style={{ fontSize: 13, color: 'grey' }}>{ feature }</span>
      </span>
    });

    let isCore = plan_key === 'core';
    let isCoreYearly = isCore && this.state.core_yearly;

    let height     = isMobileOnly ? 320 : 280;
    let width      = isMobileOnly ? 210 : '';
    let text_width = isMobileOnly ? 250 : 350;

    return <div className='flex-container-column create-practice-plan-column' style={{ width: width, minWidth: width, maxWidth: width, justifyContent: 'space-between', borderColor: selected ? '#1dc2ff' : '', padding: selected ? 8 : '', borderWidth: selected ? 4 : '' }}>
      <div className='flex-container-column'>
        <span className='create-practice-plan-name' style={{ }}>{ plan_name }</span>
        <span style={{ fontSize: 13, color: 'grey', height: 50, textAlign: 'center' }}>{ plan_sub }</span>
        <div style={{ marginTop: 5, marginBottom: 5}}>
          { features_rows }
        </div>
      </div>
      <div className='flex-container-column'>
      { isCore ? <div className='flex-container-column' style={{ alignItems: 'center' }}>
            <Switch on={!this.state.core_yearly} small={true} onClick={this.switchCoreTimeFrame} />
            {isCoreYearly ?
              <div className='flex-container-column' style={{ alignItems: 'center' }}>
                <span style={{ fontSize: 12, color: 'grey', marginLeft: 5, marginTop: 5 }}>{ 'Bill Monthly' }</span>
              </div> :
              <div className='flex-container-column' style={{ alignItems: 'center' }}>
                <span style={{ fontSize: 12, color: 'grey', marginLeft: 5, marginTop: 5 }}>{ 'Bill Monthly' }</span>
              </div>
            }
          </div> : null }
          {isCore ? <span style={{ alignSelf: 'center', color: '#1dc2ff', fontSize: 16, marginTop: 10 }}>{ this.state.core_yearly    ? price_yer : price_mon }</span>
                  : <span style={{ alignSelf: 'center', color: '#1dc2ff', fontSize: 16, marginTop: 10 }}>{ this.state.display_yearly ? price_yer : price_mon }</span> }

        <div className='flex-container-column' style={{ height: 50, justifyContent: 'center', alignItems: 'center' }}>
        { selected ? <div className='flex-container-row' style={{ alignItems: 'center', paddingBottom: 4 }}>
                       <span className='far fa-check-circle' style={{ fontSize: 18, marginRight: 4, color: '#1dc2ff' }} />
                       <span style={{ fontSize: 14, color: '#575757', paddingRight: 15, fontWeight: 'bold' }}>Selected</span>
                     </div>
                   : <Button value={btn_title} style={{ paddingRight: 40, paddingLeft: 40 }} onClick={ () => { this.setState({ ...this.state, selected_plan: plan_key })}}/> }
        </div>
      </div>
    </div>
  }

  renderIntro = () => {
    return <div className="standard-container">
      <div className="flex-container-column" style={{ padding: 15 }}>
        <span style={{ alignSelf: 'center', fontSize: 22, fontWeight: 'bold', marginBottom: 15, color: '#575757' }}>Welcome To TeleTails</span>
        <span style={{ fontSize: 14, color: 'grey', marginBottom: 18 }}>Want to join an existing practice on TeleTails? Contact the Admin of the Practice to request an invite. Otherwise get started instantly by creating a practice.</span>
        <Button value='Create A New Practice' style={{ alignSelf: 'center', paddingRight: 35, paddingLeft: 35, paddingTop: 15, paddingBottom: 15 }}/>
      </div>
    </div>
  }

  renderNewUserSection = () => {
    let height     = isMobileOnly ? 320 : 280;
    let width      = isMobileOnly ? 300 : '';
    let text_width = isMobileOnly ? 250 : 350;

    return <div className='flex-container-column'>
      <div className="standard-container" style={{ width: width, maxWidth: width, minWidth: width, height: height, maxHeight: height, minHeight: height, padding: 15 }}>

        <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 10 }}>
          <span style={{ fontWeight: 'bold', fontSize: 14, letterSpacing: 0.4, color: '#575757', marginBottom: 10 }}>First from your Practice?</span>
          <span style={{ fontSize: 13, color: 'grey', width: text_width, textAlign: 'center' }}>Are you the first member of your practice to join TeleTails?</span>
          <Button value={'Get Started'}
                  style={{ width: 250, textAlign: 'center', marginTop: 15, paddingTop: 15, paddingBottom: 15 }}
                  onClick={ () => {
                    this.setState({ ...this.state, displayCreateComponents: true });
                  }}/>
        </div>

        <Line style={{ marginTop: 20, marginBottom: 20 }} />

        <div className='flex-container-column' style={{ alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold', fontSize: 14, letterSpacing: 0.4, color: '#575757', marginBottom: 10 }}>Practice Already on TeleTails?</span>
          <span style={{ fontSize: 13, color: 'grey', textAlign: 'center', width: text_width }}>Ask the practice Admin or Practice Manager to invite you to connect with your practice on TeleTails.</span>
        </div>

      </div>
    </div>
  }

  render() {
    let hide_back_button  = this.state.display_section === 'plans' && this.props.home_screen && this.props.home_screen === true;
    let hide_title        = this.props.home_screen && this.props.home_screen === true ? true : false;
    let back_button_width = isMobileOnly ? 320 : '';

    if (this.props.home_screen === true && !this.state.displayCreateComponents) {
      return this.renderNewUserSection();
    }


    return <div className='flex-container-column'>
      <div className='flex-container-row' style={{ justifyContent: 'space-between', marginBottom: 10, marginTop: hide_title ? -20 : 10 }}>

        <div className='flex-container-row' style={{ minWidth: back_button_width, flex: 1, justifyContent: 'flex-start', alignItems: 'center' }}>
          { hide_back_button ? null : <span className="fas fa-arrow-circle-left single-screen-nav-bar-back-button"
                style={{ paddingLeft: 20 }}
                onClick={ () => { this.performBackAction() }}></span> }
          { hide_back_button ? null : <span style={{ marginLeft: 10, color: '#575757' }}>{ this.getSectionTitle() }</span> }
        </div>

        { hide_title ? null : <div className='flex-container-column' style={{ alignItems: 'center' }}>
          <span style={{ fontSize: 24, fontWeight: 'bold', color: '#1dc2ff', marginBottom: -8, marginTop: -8 }}>teletails</span>
          <span style={{ fontSize: 11, letterSpacing: 1, color: 'grey' }}>SUBSCRIPTION</span>
        </div> }

        <div style={{ flex: 1 }}></div>
      </div>
      { this.renderCreatePractice() }
    </div>
  }

  processCreatePractice = () => {
    let is_instant      = this.state.selected_plan === 'instant';
    let is_instant_paid = this.state.selected_plan === 'instant_paid';
    let is_core         = this.state.selected_plan === 'core';
    let is_enterprise   = this.state.selected_plan === 'enterprise';

    let plan_details    = this.getPlanDetails(this.state.selected_plan);

    let price, subscription_timeframe;

    subscription_timeframe = is_core && !this.state.core_yearly ? 'month' : 'year';
    price = is_core && !this.state.core_yearly ? plan_details.subscription_amount_month : plan_details.subscription_amount;

    let practice_data = {
      subscription_timeframe,
      price,
      practice_name: this.state.practice_name,
      practice_type: 'MEDICAL',
      street_address: this.state.practice_street_address,
      city: this.state.practice_city,
      state: this.state.practice_state,
      zipcode: this.state.practice_zipcode,
      location_name: this.state.practice_location_name,
      location_phone: this.state.practice_phone_number,
      subscription_type: plan_details.subscription_type,
    }

    if (is_instant_paid || is_core) {
      practice_data['cc_num']       = this.state.card_number;
      practice_data['cc_cvc']       = this.state.card_cvv;
      practice_data['cc_exp_month'] = this.state.card_month;
      practice_data['cc_exp_year']  = this.state.card_year;
      practice_data['billing_street_address']         = this.state.billing_street_address;
      practice_data['billing_street_address_line_2']  = this.state.billing_street_address_line_2;
      practice_data['billing_city']    = this.state.billing_city;
      practice_data['billing_state']   = this.state.billing_state;
      practice_data['billing_zipcode'] = this.state.billing_zipcode;
    }

    if (is_enterprise) {
      practice_data['enterprise_content']  = {
        contact_name: this.state.contact_name,
        contact_phone_number: this.state.contact_phone_number,
        contact_email: this.state.contact_email,
        activated: false,
      };
    }

    let token   = this.props.token;
    let user_id = this.props.user_id;
    if (token) {
      this.setState({ ...this.state, loading_subscribe: true });
      this.props.practiceActions.createPracticeAndSubscription(token, user_id, practice_data, this.create_success_callback, this.create_failure_callback);
    }
  }

  create_success_callback = () => {
    this.setState({ ...this.state, loading_subscribe: false });
  }

  create_failure_callback = () => {
    this.setState({ ...this.state, loading_subscribe: false });
  }

  performBackAction = () => {
    let is_instant    = this.state.selected_plan === 'instant';
    let is_enterprise = this.state.selected_plan === 'enterprise';
    let with_payment  = this.state.selected_plan === 'instant_paid' || this.state.selected_plan === 'core';

    if (this.state.display_section === 'plans' && this.props.full_screen && this.props.full_screen === true) {
      history.goBack();
    }

    if (this.state.display_section === 'practice_details') {
      this.setState({ ...this.state, display_section: 'plans' });
    }
    if (this.state.display_section === 'payment') {
      this.setState({ ...this.state, display_section: 'practice_details' });
    }
    if (this.state.display_section === 'contact') {
      this.setState({ ...this.state, display_section: 'practice_details' });
    }
    if (this.state.display_section === 'summary' && is_instant) {
      this.setState({ ...this.state, display_section: 'practice_details' });
    }
    if (this.state.display_section === 'summary' && is_enterprise) {
      this.setState({ ...this.state, display_section: 'contact' });
    }
    if (this.state.display_section === 'summary' && with_payment) {
      this.setState({ ...this.state, display_section: 'payment' });
    }
  }

  getPlanDetails = (plan_key) => {
    let all_subscriptions = this.state.subscription_types || [];
    let subscription_dict = {};

    all_subscriptions.forEach((sub, i) => {
      let key     = sub.subscription_type.toLowerCase();
      let content = sub && sub.content ? sub.content : {};
      subscription_dict[key] = content;
    });

    return subscription_dict[plan_key] ? subscription_dict[plan_key] : {};
  }

  getContinueButtonTitle = () => {
    let plan_key       = this.state.selected_plan;
    let continue_title = 'Continue With Instant'
        continue_title = plan_key === 'instant_paid' ? 'Continue with Instant+'     : continue_title;
        continue_title = plan_key === 'core'         ? 'Continue with Professional' : continue_title;
        continue_title = plan_key === 'enterprise'   ? 'Continue with Enterprise'   : continue_title;

    return continue_title;
  }

  getSectionTitle = () => {
    let display_section = this.state.display_section;
    let section_title   = 'Plan Selection'
        section_title   = display_section === 'practice_details' ? 'Practice Details'  : section_title;
        section_title   = display_section === 'payment'          ? 'Payment Info'      : section_title;
        section_title   = display_section === 'summary'          ? 'Summary'           : section_title;
    return section_title;
  }

  validatePracticeDetails = () => {
    let no_field_empty = true;
    if (!this.state.practice_name || !this.state.practice_location_name || !this.state.practice_street_address || !this.state.practice_city || !this.state.practice_state || !this.state.practice_zipcode || !this.state.practice_phone_number) {
      no_field_empty = false;
    }
    return no_field_empty;
  }

  validatePayment = () => {
    let no_field_empty = true;
    if (!this.state.cardholder_name || !this.state.card_number || !this.state.card_month || !this.state.card_year || !this.state.card_cvv || !this.state.billing_street_address || !this.state.billing_city || !this.state.billing_state || !this.state.billing_zipcode) {
      no_field_empty = false;
    }
    return no_field_empty;
  }

  validateContactInfo = () => {
    let no_field_empty = true;
    if (!this.state.contact_name || !this.state.contact_phone_number || !this.state.contact_email) {
      no_field_empty = false;
    }
    return no_field_empty;
  }

}


export default CreatePractice
